import omit from 'lodash/omit';
import querystring from 'querystring';

export default function ({ redirect, route }) {
  const { query, path: currentPath } = route;

  // Conditional so don't have to do regex on every route change
  if (currentPath.indexOf('/browse/') > -1) {
    const re = /(\/browse\/)(?<status>\w+)/;
    const pathMatch = re.exec(currentPath);

    if (pathMatch && pathMatch.groups && pathMatch.groups.status) {
      redirect(`/browse?status=${pathMatch.groups.status}`);
    }
  }

  if (query.redirect) {
    const restQuery = omit(query, ['redirect']);
    const restQueryStr = querystring.stringify(restQuery);
    const searchStr = restQueryStr ? `?${restQueryStr}` : '';
    const path = `/${query.redirect}/${searchStr}`;

    return redirect(path);
  }

  // Redirect to / if no products slug
  if (currentPath === '/products/' || currentPath === '/products') {
    return redirect('/');
  }

  return null;
}
